// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/*****************
 ** WEBPACK FOOTER
 ** c:/Users/martin.nikl/Desktop/SA GITLAB/frontend/~/babel-runtime/~/core-js/library/modules/_enum-bug-keys.js
 ** module id = 18
 ** module chunks = 0 1 2 3
 **/